module.exports = __webpack_public_path__ + "static/img/far3_active.a3c6de0a.png";